import {apiLink} from "../routes/api_link";
import {getRequest} from "../utils/request_response_utils/request";

/**
 * fetch cookies: sessionid and csrftoken
 */
export const fetchSessionCookies = () => {
    return getRequest({}, apiLink.sessions({})(null)).then((res: null) => true);
};
